// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"2051c1b4","102":"4df2baae","134":"d6c05720","261":"3adfda44","302":"8f2f0a82","408":"0fa4bde9","488":"2d3cc219","523":"f6a91db9","668":"342872fe","955":"ad8ad4c8","998":"a3e3ee9f"}[chunkId] + ".chunk.js";
};